module.exports = __webpack_public_path__ + "img/add_background.14af31bb.svg";